import { XMarkIcon } from '@heroicons/react/16/solid';
import { tTagButton } from './TagButton.types.ts';
import './TagButton.styles.scss';
import useChatInfo from '../../ChatInfoAttributes.hook.ts';
import { useState } from 'react';
import { Loading } from 'react-daisyui';
import { useAnalytics } from 'src/hooks/analytics/useAnalytics.hook';
import { getModuleName } from '../../../../../../Chat.utils.ts';
import { getTagName } from '../../ChatInfoAttributes.tag.utils.ts';

export default function TagButton(props: tTagButton) {
  const { deleteTag } = useChatInfo();
  const [loading, setLoading] = useState(false);
  const { trackEvent } = useAnalytics();
  const tagName = getTagName(props.tag);

  if (!tagName) return null;

  return (
    <div className="TagButton">
      {tagName}
      {loading ? (
        <Loading size="xs" />
      ) : (
        <XMarkIcon
          onClick={async () => {
            setLoading(true);
            try {
              await deleteTag(tagName);
              trackEvent('front.chat.attributes.update.tag.change', {
                displayName: 'Update etiqueta',
                description: 'Con qué frecuencia se crean o eliminan etiquetas',
                ctaType: getModuleName(),
                tagStatus: 'Delete',
              });
            } finally {
              setLoading(false);
            }
          }}
          className="TagButton__Xicon"
        />
      )}
    </div>
  );
}
